import { render, staticRenderFns } from "./ModalDriversLicenceTypeNew.vue?vue&type=template&id=4cfca5e4&"
import script from "./ModalDriversLicenceTypeNew.vue?vue&type=script&lang=js&"
export * from "./ModalDriversLicenceTypeNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports